import { VERSION } from '@configs/constants';

const bytenize = (str) =>{
  str = str ?? ""
  var bytes = [];
  var charCode;

  for (var i = 0; i < str.length; ++i)
  {
      charCode = str.charCodeAt(i);
      bytes.push((charCode & 0xFF00) >> 8);
      bytes.push(charCode & 0xFF);
  }
  return bytes.join(' ');
}
const getSessionId = () =>{
  return window.socket.id;
}
export const socketLoginAction = (userAccount) => {
    console.log('socketLoginAction')
    return dispatch => {
        dispatch({
            type: "INIT_SOCKET",
            data: null,
            socket:window.socket
        });
        setTimeout(()=>{
            window.socket.emit('action', {
                action:'login',
                version:VERSION,
                userAccount:{...userAccount, s:bytenize(getSessionId()),ssn:localStorage.getItem('ssn', null)}
            })
        }, 500)
    }
}
export const requestNonce = (userAccount) => {
    console.log('requestNonce')
    return dispatch => {
        dispatch({
            type: "INIT_SOCKET",
            data: null,
            socket:window.socket
        });
        setTimeout(()=>{
            window.socket.emit('action', {
                action:'requestNonce'
            })
        }, 500)
    }
}

export const getArcadexList = () => {
    return dispatch => {
        window.socket.emit('action', {
            action:'getArcadexList'
        })
        dispatch({
            type: "GET_ARCADEX_LIST"
        });
    }
}
export const getAchievementsList = () => {
    return dispatch => {
        window.socket.emit('action', {
            action:'getAchievementsList'
        })
        dispatch({
            type: "GET_ACHIEVEMENTS_LIST"
        });
    }
}
export const getMarketSalesList = () => {
    return dispatch => {
        window.socket.emit('action', {
            action:'getMarketSalesList'
        })
        dispatch({
            type: "GET_MARKET_SALES_LIST"
        });
    }
}
export const getMarketSalesWeeklyList = () => {
    return dispatch => {
        window.socket.emit('action', {
            action:'getMarketSalesWeeklyList'
        })
        dispatch({
            type: "GET_MARKET_SALES_WEEKLY_LIST"
        });
    }
}
export const getMarketSalesMonthlyList = () => {
    return dispatch => {
        window.socket.emit('action', {
            action:'getMarketSalesMonthlyList'
        })
        dispatch({
            type: "GET_MARKET_SALES_MONTHLY_LIST"
        });
    }
}
export const getRankRolls = () => {
    return dispatch => {
        window.socket.emit('action', {
            action:'getRankRolls'
        })
        dispatch({
            type: "GET_RANK_ROLLS"
        });
    }
}
export const getRanksList = () => {
    return dispatch => {
        window.socket.emit('action', {
            action:'getRanksList'
        })
        dispatch({
            type: "GET_RANKS_LIST"
        });
    }
}
export const publishEvent = (newsEvent) => {
    console.log(['publishEvent', newsEvent])
    return dispatch => {
        window.socket.emit('action', {
            action:'publishEvent',
            data:newsEvent
        })
        dispatch({
            type: "PUBLISH_EVENT"
        });
    }
}

export const getLatestNews = () => {
    return dispatch => {
        window.socket.emit('action', {
            action:'getLatestNews'
        })
        dispatch({
            type: "GET_LATEST_NEWS"
        });
    }
}
export const readLatestNews = (maxId) => {
    return dispatch => {
        window.socket.emit('action', {
            action:'readLatestNews',
            data:{maxId}
        })
        dispatch({
            type: "READ_LATEST_NEWS"
        });
    }
}
export const getAssetsMarketPrice = (assets) => {
    console.log(['assets', assets])
    return dispatch => {
        window.socket.emit('action', {
            action:'getAssetsMarketPrice',
            data:{assets}
        })
        dispatch({
            type: "GET_ASSETS_MARKET_PRICE"
        });
    }
}
export const registerPartnerNFT = (asset_id) => {
    return dispatch => {
        window.socket.emit('action', {
            action:'registerPartnerNFT',
            data:{asset_id}
        })
        dispatch({
            type: "REGISTER_PARTNER_NFT_START"
        });
    }
}
export const enableAutoRepair = (mining_id) => {
    return dispatch => {
        window.socket.emit('action', {
            action:'enableAutoRepair',
            data:{mining_id}
        })
        dispatch({
            type: "ENABLE_AUTO_REPAIR"
        });
    }
}
export const disableAutoRepair = (mining_id) => {
    return dispatch => {
        window.socket.emit('action', {
            action:'disableAutoRepair',
            data:{mining_id}
        })
        dispatch({
            type: "DISABLE_AUTO_REPAIR"
        });
    }
}
export const repairFilteredOperations = (minings) => {
    return dispatch => {
        window.socket.emit('action', {
            action:'repairFilteredOperations',
            data:{minings}
        })
        dispatch({
            type: "REPAIR_ASSETS_START"
        });
    }
}

export const autoRepairFilteredOperations = (minings) => {
    return dispatch => {
        window.socket.emit('action', {
            action:'autoRepairFilteredOperations',
            data:{minings}
        })
        dispatch({
            type: "AUTO_REPAIR_ASSETS_START"
        });
    }
}

export const repairAssets = (assets) => {
    console.log('repairAssets', assets)
    return dispatch => {
        window.socket.emit('action', {
            action:'repairAssets',
            data:{assets}
        })
        dispatch({
            type: "REPAIR_ASSETS_START"
        });
    }
}

export const setNewPassword = (password, confirm_password, password_request_id) => {
    return dispatch => {
        window.socket.emit('action', {
            action:'setNewPassword',
            data:{password, confirm_password, password_request_id}
        })
        dispatch({
            type: "START_PASSWORD_SETUP"
        });
    }
}

export const startPasswordSetup = () => {
    return dispatch => {
        dispatch({
            type: "START_PASSWORD_SETUP"
        });
    }
}
export const getWaxPoolHistory = () => {
    return dispatch => {
        window.socket.emit('action', {
            action:'getWaxPoolHistory'
        })
        dispatch({
            type: "GET_WAX_POOL_HISTORY"
        });
    }
}
export const getLPLeaderboard = () => {
    return dispatch => {
        window.socket.emit('action', {
            action:'getLPLeaderboard'
        })
        dispatch({
            type: "GET_LP_LEADERBOARD"
        });
    }
}
export const getAllMyAssets = () => {
    return dispatch => {
        window.socket.emit('action', {
            action:'getAllMyAssets'
        })
        dispatch({
            type: "GET_ALL_MY_ASSETS"
        });
    }
}
export const getCommonOnePromoAssets = () => {
    return dispatch => {
        window.socket.emit('action', {
            action:'getCommonOnePromoAssets'
        })
        dispatch({
            type: "GET_C1_PROMO_ASSETS"
        });
    }
}

export const getMiningOperationHistory = (mining_id) => {
    return dispatch => {
        window.socket.emit('action', {
            action:'getMiningOperationHistory',
            data:{mining_id}
        })
        dispatch({
            type: "GET_MINING_OPERATION_HISTORY"
        });
    }
}

export const getMiningOperationsHistory = (mining_id) => {
    return dispatch => {
        window.socket.emit('action', {
            action:'getMiningOperationsHistory',
            data:{mining_id}
        })
        dispatch({
            type: "GET_MINING_OPERATIONS_HISTORY"
        });
    }
}

export const getPartnersNFTList = (mining_id) => {
    return dispatch => {
        window.socket.emit('action', {
            action:'getPartnersNFTList'
        })
        dispatch({
            type: "GET_PARTNERS_NFT_LIST"
        });
    }
}

export const getWalletHistory = (resource_id) => {
    return dispatch => {
        window.socket.emit('action', {
            action:'getWalletHistory',
            data:{resource_id}
        })
        dispatch({
            type: "GET_WALLET_HISTORY"
        });
    }
}

export const startBuyProcess = () => {
    return dispatch => {
        dispatch({
            type: "START_BUY_PROCESS"
        });
    }
}
export const socketDisconnected = () => {
    return dispatch => {
        dispatch({
            type: "SOCKET_DISCONNECTED"
        });
    }
}
export const socketConnected = () => {
    return dispatch => {
        dispatch({
            type: "SOCKET_CONNECTED"
        });
    }
}
export const endBuyProcess = () => {
    return dispatch => {
        dispatch({
            type: "END_BUY_PROCESS"
        });
    }
}
export const getWaxUsd = () => {
    return dispatch => {
        window.socket.emit('action', {
            action:'getWaxUsd'
        })
        dispatch({
            type: "GET_WAX_USD"
        });
    }
}
export const getSalesList = () => {
    return dispatch => {
        window.socket.emit('action', {
            action:'getSalesList'
        })
        dispatch({
            type: "GET_SALES_LIST"
        });
    }
}

export const getEventRollsList = (event_id, season = 0) => {
    return dispatch => {
        window.socket.emit('action', {
            action:'getEventRollsList',
            data:{event_id, season}
        })
        dispatch({
          type: "GET_EVENT_ROLLS_LIST"
        });
    }
}
export const getLPOwnersList = () => {
    return dispatch => {
        window.socket.emit('action', {
            action:'getLPOwnersList'
        })
        dispatch({
          type: "GET_LP_OWNERS_LIST"
        });
    }
}
export const getSaleTicketsList = (sale_id) => {
    return dispatch => {
        window.socket.emit('action', {
            action:'getSaleTicketsList',
            data:{sale_id}
        })
        dispatch({
            type: "GET_SALE_LIST"
        });
    }
}
export const joinSecondLevelSale = (sale_id) => {
    return dispatch => {
        window.socket.emit('action', {
            action:'joinSecondLevelSale',
            data:{sale_id}
        })
        dispatch({
            type: "JOIN_SECOND_LEVEL"
        });
    }
}
export const getSale = (sale_id) => {
    return dispatch => {
        window.socket.emit('action', {
            action:'getSale',
            data:{sale_id}
        })
        dispatch({
            type: "GET_SALE"
        });
    }
}

export const getPartnersPoolList = () => {
    return dispatch => {
        window.socket.emit('action', {
            action:'getPartnersPoolList'
        })
        dispatch({
            type: "GET_PARTNERS_POOL_LIST"
        });
    }
}
export const getOpenHistory = () => {
    return dispatch => {
        window.socket.emit('action', {
            action:'getOpenHistory'
        })
    }
}

export const saveCardType = (cardType) => {
    return dispatch => {
        window.socket.emit('action', {
            action:'saveCardType',
            cardType:cardType
        })
        dispatch({
            type: "SOCKET_SAVING"
        });
    }
}
export const getLastLottery = () => {
    return dispatch => {
        window.socket.emit('action', {
            action:'getLastLottery'
        })
        dispatch({
            type: "GET LAST LOTTERY"
        });
    }
}
export const resetSlotsRewardAsset = () => {
    return dispatch => {
        dispatch({
            type: "RESET_SLOTS_REWARD"
        });
    }
}
export const rollSots = () => {
    return dispatch => {
        window.socket.emit('action', {
            action:'rollSots'
        })
        dispatch({
            type: "ROLL_SLOTS"
        });
    }
}
export const endOpeningPack = () => {
    return dispatch => {
        dispatch({
            type: "END_OPENING_PACK"
        });
    }
}

export const endLevelingUp = () => {
    return dispatch => {
        dispatch({
            type: "END_LEVEL_UP"
        });
    }
}

export const startFusing = () => {
    return dispatch => {
        dispatch({
            type: "START_FUSING"
        });
    }
}
export const startLevelingUp = () => {
    return dispatch => {
        dispatch({
            type: "START_LEVEL_UP"
        });
    }
}

export const startBlending = () => {
    return dispatch => {
        dispatch({
            type: "START_BLENDING"
        });
    }
}

export const startStickerBurn = () => {
    return dispatch => {
        dispatch({
            type: "START_STICKER_BURN"
        });
    }
}

export const endStickerBurn = () => {
    return dispatch => {
        dispatch({
            type: "END_STICKER_BURN"
        });
    }
}

export const startOpeningPack = () => {
    return dispatch => {
        dispatch({
            type: "START_OPENING_PACK"
        });
    }
}


export const getLotteryEntries = () => {
    console.log(['getLotteryEntries'])
    return dispatch => {
        window.socket.emit('action', {
            action:'getLotteryEntries'
        })
        dispatch({
            type: "GET_LOTTERY_ENTRIES"
        });
    }
}

export const saveCardTypes = (cardTypes) => {
    return dispatch => {
        window.socket.emit('action', {
            action:'saveCardTypes',
            cardTypes:cardTypes
        })
        dispatch({
            type: "SOCKET_SAVING"
        });
    }
}
export const getAllCardsTypes = (userAccount) => {
    return dispatch => {
        window.socket.emit('action', {
            action:'getAllCardsTypes'
        })
    }
}
export const socketActionHandler = (data) => {
    if(window.showSocketLog)
        console.log(['socketActionHandler', data])
    return dispatch => {
        if(window.showSocketLog)
            console.log(['socketActionHandler dispatch', data])
        dispatch({
            type: "SOCKET_ACTION",
            data: data
        });
        
    }
}

export const getMarketList = (data) => {
    console.log(['getMarketList', data])
    return dispatch => {
        window.socket.emit('action', {
            action:'getMarketList',
            data:data
        })
        dispatch({
            type: "SOCKET_GET_MARKET_LIST_INIT",
            page: data.page,
        });
        
    }
}
export const getAssetInfo = (asset_id) => {
    return dispatch => {
        window.socket.emit('action', {
            action:'getAssetInfo',
            data:{asset_id}
        })
    }
}
export const sendMetalPosterFormData = (user_id, name, street, address, post, city, area, country, contact) => {
    return dispatch => {
        window.socket.emit('action', {
            action: 'sendMetalPosterFormData',
            data:{user_id, name, street, address, post, city, area, country, contact}
        })
        dispatch({
            type: "METAL_POSTER_FORM_DATA"
        });
    }
}
export const getMiningOperationInfo = (mining_id) => {
    return dispatch => {
        window.socket.emit('action', {
            action:'getMiningOperationInfo',
            data:{mining_id}
        })
    }
}
/*
socket.on('action', function (data) {
    socketActionHandler(data)
});*/

export const resendAllOperations = () => {
    return dispatch => {
        window.socket.emit('action', {
            action:'resendAllOperations'
        })
        dispatch({
            type: "RESEND_ALL_MINING_OPERATIONS"
        });
        
    }
}


export const cancelAllOperations = () => {
    return dispatch => {
        window.socket.emit('action', {
            action:'cancelAllOperations'
        })
        dispatch({
            type: "CANCEL_ALL_MINING_OPERATIONS"
        });
        
    }
}

export const resendFilteredOperations = (minings) => {
    console.log(minings)
    return dispatch => {
        window.socket.emit('action', {
            action:'resendFilteredOperations',
            minings:minings
        })
        dispatch({
            type: "RESEND_FILTERED_MINING_OPERATIONS"
        });
        
    }
}

export const cancelFilteredOperations = (minings) => {
    console.log(minings)
    return dispatch => {
        window.socket.emit('action', {
            action:'cancelFilteredOperations',
            minings:minings
        })
        dispatch({
            type: "CANCEL_ALL_MINING_OPERATIONS"
        });
        
    }
}

export const disbandMiningFilteredOperations = (minings) => {
    console.log(minings)
    return dispatch => {
        window.socket.emit('action', {
            action:'disbandMiningFilteredOperations',
            minings:minings
        })
        dispatch({
            type: "SOCKET_DISBAND_MINING_OPERATION"
        });

    }
}

export const saveMiningOperation = (miningOperation) => {
    return dispatch => {
        window.socket.emit('action', {
            action:'saveMiningOperation',
            data:miningOperation
        })
        dispatch({
            type: "SOCKET_SAVE_MINING_OPERATION"
        });
        
    }
}

export const saveDeck = (deck) => {
    return dispatch => {
        window.socket.emit('action', {
            action:'saveDeck',
            data:deck
        })
        dispatch({
            type: "SOCKET_SAVE_DECK"
        });
    }
}
export const saveAssetsToBattle = (deck) => {
    console.log('deck', deck);
    return dispatch => {
        window.socket.emit('action', {
            action:'saveAssetsToBattle',
            data:deck
        })
        dispatch({
            type: "SOCKET_SAVE_ASSETS_TO_BATTLE"
        });
    }
}

export const saveLockedActives = (deck) => {
    return dispatch => {
        window.socket.emit('action', {
            action:'saveLockedActives',
            data:deck
        })
        dispatch({
            type: "SOCKET_SAVE_LOCKED_ACTIVES"
        });
    }
}
export const saveSortedActives = (deck) => {
    return dispatch => {
        window.socket.emit('action', {
            action:'saveSortedActives',
            data:deck
        })
        dispatch({
            type: "SOCKET_SAVE_SORTED_ACTIVES"
        });
    }
}
export const acceptBattle = (id) => {
    return dispatch => {
        window.socket.emit('action', {
            action:'acceptBattle',
            data:id
        })
        dispatch({
            type: "SOCKET_ACCEPT_BATTLE"
        });
    }
}
export const getShopConsumables = () => {
    return dispatch => {
        window.socket.emit('action', {
            action:'getShopConsumables'
        })
        dispatch({
            type: "GET_SHOP_CONSUMABLES"
        });
    }
}
export const buyConsumables = (id) => {
    return dispatch => {
        window.socket.emit('action', {
            action:'buyConsumables',
            data:id
        })
        dispatch({
            type: "BUY_CONSUMABLES"
        });
    }
}
export const consumableUse = (data) => {
    return dispatch => {
        window.socket.emit('action', {
            action:'consumableUse',
            data:data
        })
        dispatch({
            type: "CONSUMABLE_USE"
        });
    }
}
export const getDecks = () => {
    return dispatch => {
        window.socket.emit('action', {
            action:'getDecks'
        })
        dispatch({
            type: "SOCKET_GET_DECKS"
        });
    }
}
export const getBattleLobby = () => {
    return dispatch => {
        window.socket.emit('action', {
            action:'getBattleLobby'
        })
        dispatch({
            type: "SOCKET_GET_BATTLE_LOBBY"
        });
    }
}
export const saveBattleLobby = (data) => {
    return dispatch => {
        window.socket.emit('action', {
            action:'saveBattleLobby',
            data:{data}
        })
        dispatch({
            type: "SOCKET_SAVE_BATTLE_LOBBY"
        });
    }
}
export const acceptFriendlyBattle = (id) => {
    return dispatch => {
        window.socket.emit('action', {
            action:'acceptFriendlyBattle',
            data:id
        })
        dispatch({
            type: "SOCKET_FRIENDLY_ACCEPT_BATTLE"
        });
    }
}
export const getFriendlyLobby = () => {
    return dispatch => {
        window.socket.emit('action', {
            action:'getFriendlyLobby',
        })
        dispatch({
            type: "SOCKET_GET_FRIENDLY_LOBBY"
        });
    }
}
export const searchFriendlyBattle = (data) => {
    return dispatch => {
        window.socket.emit('action', {
            action:'searchFriendlyBattle',
            data:{data}
        })
        dispatch({
            type: "SOCKET_SEARCH_FRIENDLY_BATTLE"
        });
    }
}
export const cancelFriendlyBattle = (id) => {
    return dispatch => {
        window.socket.emit('action', {
            action:'cancelFriendlyBattle',
            data:{lobby_id:id}
        })
        dispatch({
            type: "SOCKET_CANCEL_FRIENDLY_BATTLE"
        });
    }
}
export const getLeaderBoards = () => {
    return dispatch => {
        window.socket.emit('action', {
            action:'getLeaderBoards'
        })
        dispatch({
            type: "SOCKET_GET_LEADER_BOARDS"
        });
    }
}
export const getPrevLeaderBoards = (from,to) => {
    return dispatch => {
        window.socket.emit('action', {
            action:'getPrevLeaderBoards',
            data:{from:from, to:to},
        })
        dispatch({
            type: "SOCKET_GET_PREV_LEADER_BOARDS"
        });
    }
}
export const deleteDeck = (deck_id) => {
    return dispatch => {
        window.socket.emit('action', {
            action:'deleteDeck',
            data:{deck_id}
        })
        dispatch({
            type: "SOCKET_DELETE_DECKS"
        });
    }
}
export const leaveBattleLobby = () => {
    return dispatch => {
        window.socket.emit('action', {
            action:'leaveBattleLobby'
        })
        dispatch({
            type: "SOCKET_LEAVE_BATTLE_LOBBY"
        });
    }
}
export const getBattle = () => {
    return dispatch => {
        window.socket.emit('action', {
            action:'getBattle',
        })
        dispatch({
            type: "SOCKET_GET_BATTLE_DATA"
        });
    }
}
export const surrenderBattle = () => {
    return dispatch => {
        window.socket.emit('action', {
            action:'surrenderBattle',
        })
        dispatch({
            type: "SOCKET_SURRENDER_BATTLE"
        });
    }
}
export const battleAttack = (asset_id) => {
    return dispatch => {
        window.socket.emit('action', {
            action:'battleAttack',
            data:asset_id
        })
        dispatch({
            type: "SOCKET_BATTLE_ATTACK"
        });
    }
}

export const getMiningOperations = () => {
    return dispatch => {
        window.socket.emit('action', {
            action:'getMiningOperations'
        })
        dispatch({
            type: "SOCKET_GET_MINING_OPERATIONS"
        });
    }
}
export const getMiningOperation = (mining_id) => {
    return dispatch => {
        window.socket.emit('action', {
            action:'getMiningOperation',
            mining_id:mining_id
        })
        dispatch({
            type: "SOCKET_GET_MINING_OPERATION"
        });
    }
}
export const cancelMiningOperation = (mining_id) => {
    return dispatch => {
        window.socket.emit('action', {
            action:'cancelMiningOperation',
            mining_id:mining_id
        })
        dispatch({
            type: "SOCKET_CANCEL_MINING_OPERATION"
        });
    }
}

export const disbandMiningOperation = (mining_id) => {
    return dispatch => {
        window.socket.emit('action', {
            action:'disbandMiningOperation',
            mining_id:mining_id
        })
        dispatch({
            type: "SOCKET_DISBAND_MINING_OPERATION"
        });
    }
}
export const disbandDeckOperation = (deck_id) => {
    return dispatch => {
        window.socket.emit('action', {
            action:'disbandDeckOperation',
            deck_id:deck_id
        })
        dispatch({
            type: "SOCKET_DISBAND_DECK_OPERATION"
        });
    }
}

export const participateInTeamGuess = (data) => {
    return dispatch => {
        window.socket.emit('action', {
            action:'participateInTeamGuess',
            data:data
        })
        dispatch({
            type: "SOCKET_PARTICIPATE_IN_TEAM_GUESS"
        });
    }
}
export const getTeamGuessInfo = (data) => {
    return dispatch => {
        window.socket.emit('action', {
            action:'getTeamGuessInfo'
        })
        dispatch({
            type: "GET_TEAMS_GUESS_INFO"
        });
    }
}
export const getReferralUsers = () => {
    return dispatch => {
        window.socket.emit('action', {
            action:'getReferralUsers'
        })
        dispatch({
            type: "GET_REFERRAL_USERS"
        });
    }
}
export const setReferralUsers = (wax_wallet) => {
    return dispatch => {
        window.socket.emit('action', {
            action: 'setReferralUsers',
            data: wax_wallet
        })
        dispatch({
            type: "SET_REFERRAL_USERS"
        });
    }
}
export const isReferralUser = () => {
    return dispatch => {
        window.socket.emit('action', {
            action: 'isReferralUser'
        })
        dispatch({
            type: "IS_REFERRAL_USERS"
        });
    }
}
export const getBonus = () => {
    return dispatch => {
        window.socket.emit('action', {
            action: 'getBonus'
        })
        dispatch({
            type: "GET_BONUS"
        });
    }
}
export const updateReferringWalletLimit = (wallet_limit, NBMFUSPrice, NBMACTPrice, NBMCONPrice, NBMMINPrice) => {
    return dispatch => {
        window.socket.emit('action', {
            action: 'updateReferringWalletLimit',
            wallet_limit: wallet_limit,
            NBMFUSPrice: NBMFUSPrice,
            NBMACTPrice: NBMACTPrice,
            NBMMINPrice: NBMMINPrice,
            NBMCONPrice: NBMCONPrice
        })
        dispatch({
            type: "UPDATE_REFERRING_WALLET_LIMIT"
        });
    }
}
export const buyWchampGold = (data) => {
    return dispatch => {
        window.socket.emit('action', {
            action:'buyWchampGold',
            data:data
        })
        dispatch({
            type: "BUy_WCHAMP_GOLD"
        });
    }
}
export const getMyWallets = (data) => {
    return dispatch => {
        window.socket.emit('action', {
            action:'getMyWallets'
        })
        dispatch({
            type: "GET_MY_WALLETS"
        });
    }
}

export const getDepletionMultipliers = (data) => {
    return dispatch => {
        window.socket.emit('action', {
            action:'getDepletionMultipliers'
        })
        dispatch({
            type: "GET_DEPLETION_MULTIPLIERS"
        });
    }
}
export const createCharacterRequest = (data) => {
    return dispatch => {
        window.socket.emit('action', {
            action:'createCharacterRequest',
            data:data
        })
        dispatch({
            type: "CREATE_CHARACTER"
        });
    }
}

export const withdrawNFT = (asset_id) => {
    return dispatch => {
        window.socket.emit('action', {
            action:'withdrawNFT',
            data:{asset_id}
        })
        dispatch({
            type: "WITHDRAW_TOKENS"
        });
    }
}
export const getTradePairs = (data) => {
    return dispatch => {
        window.socket.emit('action', {
            action:'getTradePairs'        })
        dispatch({
            type: "GET_TRADE_PAIRS"
        });
    }
}
export const swapTokens = (data) => {
    return dispatch => {
        window.socket.emit('action', {
            action:'swapTokens',
            data
        })
        dispatch({
            type: "SWAP_TOKENS"
        });
    }
}
export const withdrawTokens = (data) => {
    return dispatch => {
        window.socket.emit('action', {
            action:'withdrawTokens',
            data
        })
        dispatch({
            type: "WITHDRAW_TOKENS"
        });
    }
}
export const getActiveTeamGuessHistory = () => {
    return dispatch => {
        window.socket.emit('action', {
            action:'getActiveTeamGuessHistory'
        })
        dispatch({
            type: "GET_ACTIVE_TEAM_GUESS_HISTORY"
        });
    }
}
export const updateTeamGuesSelectedNumber = (number, resource_id) => {
    return dispatch => {
        window.socket.emit('action', {
            action:'updateTeamGuesSelectedNumber',
            data:{number, resource_id}
        })
        dispatch({
            type: "UPDATE_TEAM_SELECTED_NUMBER"
        });
    }
}
export const removeTeamGuesAsset = (asset_id) => {
    return dispatch => {
        window.socket.emit('action', {
            action:'removeTeamGuesAsset',
            data:{asset_id}
        })
        dispatch({
            type: "REMOVE_TEAM_GUESS_ASSET"
        });
    }
}
export const saveOperationForCalculator = (miningOperationCardTypes) => {
    return dispatch => {
        dispatch({
            miningOperationCardTypes:miningOperationCardTypes,
            type: "SAVE_OPERATION_FOR_CALCULATOR"
        });
    }
}
export const getUserIcon  = () => {
  console.log('getUserIcon')
    return dispatch => {
        window.socket.emit('action', {
            action:'getUserIcon'
        })
        dispatch({
            type: "GET_USER_ICON"
        });
    }
}
export const getUserIcons  = () => {
    return dispatch => {
        window.socket.emit('action', {
            action:'getUserIcons'
        })
        dispatch({
            type: "GET_USER_ICONS"
        });
    }
}
export const setUserIcon  = (icon_id) => {
    return dispatch => {
        window.socket.emit('action', {
            action:'setUserIcon',
            data:{icon_id}
        })
        dispatch({
            icon_id:icon_id,
            type: "SET_USER_ICON"
        });
    }
}
export const getDiscordEvents  = () => {
    return dispatch => {
        window.socket.emit('action', {
            action:'getDiscordEvents',
        })
        dispatch({
            type: "GET_DISCORD_EVENTS"
        });
    }
}
export const getTournaments = ()=>{
    return dispatch => {
        window.socket.emit('action', {
            action:'getTournaments',
        })
        dispatch({
            type: "SOCKET_GET_TOURNAMENTS_DATA"
        });
    }
}

export const registerForTournament = (tournament_id)=>{
    return dispatch => {
        window.socket.emit('action', {
            action:'registerForTournament',
            data:tournament_id,
        })
        dispatch({
            type: "REGISTER_FOR_TOURNAMENTS"
        });
    }
}

export const leaveTournaments = ()=>{
    return dispatch => {
        window.socket.emit('action', {
            action:'leaveTournaments',
        })
        dispatch({
            type: "CANCEL_TOURNAMENTS"
        });
    }
}

export const getTournamentsHistory = ()=>{
    return dispatch => {
        window.socket.emit('action', {
            action:'getTournamentsHistory',
        })
        dispatch({
            type: "GET_TOURNAMENTS_HISTORY"
        });
    }
}
export const getTournament = ()=>{
    return dispatch => {
        window.socket.emit('action', {
            action:'getTournament',
        })
        dispatch({
            type: "SOCKET_GET_TOURNAMENT_ID"
        });
    }
}

export const getTournamentById = (tournament_id)=>{
    return dispatch => {
        window.socket.emit('action', {
            action:'getTournamentById',
            data: {tournament_id: tournament_id},
        })
        dispatch({
            type: "SOCKET_GET_TOURNAMENT_BY_ID"
        });
    }
}

export const setActiveButtonMobileMenu = (active_button_menu)=>{
    return dispatch => {
        dispatch({
            type: "SOCKET_GET_ACTIVE_BUTTON_MOBILE_MENU",
            active_button_menu: active_button_menu
        });
    }
}

export const openMenuMobile = (isOpen)=>{
    return dispatch => {
        dispatch({
            type: "OPEN_MENU_MOBILE",
            open_menu: isOpen,
        });
    }
}

